// Bootstrap tooltips
['DOMContentLoaded', 'shown.bs.modal'].forEach(function(e) {
  document.addEventListener(e, function(event) {
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"], abbr[title]'))
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
  });
});
